import styled from 'styled-components';

import { Row } from '@notino/react-styleguide-v20';

export const Wrapper = styled(Row)`
  margin-top: 1.5rem;
  display: flex;
  width: 100%;
`;

export const WrapperHeadline = styled.p`
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  user-select: none;
`;
